import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getTrackedOrderRequest,
  searchOrdersRequest,
  searchPartnerOrdersRequest,
} from './trackingApi';
import { trackingErrorMessage } from './trackingUtils';

/**
 * Looks for a customer's orders by reference and phone, by phone alone, or by
 * order id. The backend answers with the five most recent matches.
 */
export const searchOrders = createAsyncThunk(
  'tracking/searchOrders',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await searchOrdersRequest(payload);
      return response.data.orders || [];
    } catch (error) {
      console.error('Error searching orders:', error);
      return rejectWithValue(trackingErrorMessage(error));
    }
  }
);

/**
 * The partner-branded search: a reference scoped to the partner's own admin.
 */
export const searchPartnerOrders = createAsyncThunk(
  'tracking/searchPartnerOrders',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await searchPartnerOrdersRequest(payload);
      return response.data.orders || [];
    } catch (error) {
      console.error('Error searching partner orders:', error);
      return rejectWithValue(trackingErrorMessage(error));
    }
  }
);

/**
 * One order with its status history, plus the partner that manages it when
 * there is one — which is what puts a name other than ours on the header.
 */
export const fetchTrackedOrder = createAsyncThunk(
  'tracking/fetchTrackedOrder',
  async (orderId, { rejectWithValue }) => {
    try {
      const response = await getTrackedOrderRequest(orderId);
      const { serialized_order: order, serialized_admin: admin } = response.data;

      // A 200 with no order is the shape the endpoint used to answer with when
      // something went wrong inside it. Treated as a failure, not as an empty
      // page that says nothing.
      if (!order) {
        return rejectWithValue('No pudimos leer los datos de este pedido.');
      }

      return { order, admin: admin || null };
    } catch (error) {
      console.error('Error fetching tracked order:', error);
      return rejectWithValue(trackingErrorMessage(error));
    }
  }
);
